var _templateObject = _taggedTemplateLiteral([]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* eslint-disable import/first */
import styled from 'styled-components';

var Wrapper = styled.div(_templateObject);

export default Wrapper;